import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';

export type PushAudienceType =
  | 'company'
  | 'team'
  | 'marketingGroup'
  | 'brand'
  | 'existingUser'
  | 'everyone';

export interface PushAudience {
  type: PushAudienceType;
  ids?: string[];
}

export interface PushAudienceMessage {
  audience: PushAudience;
  title: string;
  message: string;
}

export interface PushAudienceSendResponse {
  recipientCount: number;
  sentCount: number;
  skippedCount: number;
  failureCount: number;
  skipped?: Array<string | {
    userId?: string;
    reason?: string;
    user?: string;
  }> | Record<string, {
    reason?: string;
    user?: string;
  }>;
  skippedByUserId?: Record<string, {
    reason: string;
    user?: string;
  }>;
  failures: Array<{
    userId: string;
    error: string;
    user?: string;
  }>;
}

@Injectable({
  providedIn: 'root',
})
export class PushNotificationsService {
  constructor(private restangular: Restangular) {}

  sendMessageToUser(userId: string, title: string, message: string): Promise<any> {
    return this.restangular.one('v3').one('gcm').one(userId).one('messages').one('send').customPUT({ title, message }).toPromise();
  }

  sendMessageToChannel(channel: string, title: string, message: string): Promise<any> {
    return this.restangular.one('v3').one('gcm').one('messages').one('channel', channel).one('send').customPUT({ title, message }).toPromise();
  }

  sendAudienceMessage(payload: PushAudienceMessage): Promise<PushAudienceSendResponse> {
    return this.restangular.one('v3').one('gcm').one('messages').one('audience').one('send').customPUT(payload).toPromise();
  }
}
